// PR #42 perbaikan 2 butir 1 (Haryanto 27/10/2026): produk target diskon pilihan pembeli di keranjang HP, satu per kategori + `aktif`
// (produk yang terakhir disentuh → kategori bar pengingat). Sumber kebenaran = memori halaman; sessionStorage hanya supaya pilihan bertahan
// selama sesi (muat ulang). Storage diblokir/rusak → pilihan tetap berlaku sampai halaman dimuat ulang (review Codex). Dikirim ke server sebagai
// ?sasaran=…&aktif=… — server yang memeriksa id (ada di keranjang, bisa dibeli) dan menghitung semua angka.
const KUNCI = "hs_keranjang_sasaran";
let memori = null;   // { perKat: {kategori: id}, aktif: id } — dibaca dari sessionStorage sekali per muat halaman

function sah(v) {
  if (!v || typeof v !== "object" || !v.perKat || typeof v.perKat !== "object" || Array.isArray(v.perKat)) return null;
  const perKat = {};
  for (const [k, pid] of Object.entries(v.perKat)) if (typeof pid === "string" && pid) perKat[k] = pid;
  return { perKat, aktif: typeof v.aktif === "string" ? v.aktif : "" };
}

export function bacaSasaran() {
  if (!memori) {
    try { memori = sah(JSON.parse(window.sessionStorage.getItem(KUNCI) || "null")); } catch { /* diblokir / isi rusak → tanpa pilihan */ }
    if (!memori) memori = { perKat: {}, aktif: "" };
  }
  return { perKat: { ...memori.perKat }, aktif: memori.aktif };
}

function simpan(v) {
  memori = { perKat: { ...v.perKat }, aktif: v.aktif };
  try { window.sessionStorage.setItem(KUNCI, JSON.stringify(memori)); } catch { /* diabaikan: pilihan tetap di memori halaman */ }
}

/** Pilih produk sebagai target kategorinya dan jadikan aktif (bar). Mengembalikan false bila tidak ada yang berubah. */
export function pilihSasaran(kategori, pid) {
  const v = bacaSasaran();
  if (v.perKat[kategori] === pid && v.aktif === pid) return false;
  v.perKat[kategori] = pid;
  v.aktif = pid;
  simpan(v);
  return true;
}

/** Buang pilihan yang produknya sudah tidak ada di keranjang (dihapus) → kategori itu kembali ke bawaan. */
export function rapikanSasaran(summary) {
  if (!summary || !Array.isArray(summary.categories)) return;
  const ada = new Set(summary.categories.flatMap((c) => c.items.map((it) => it.produk_id)));
  const v = bacaSasaran();
  let ubah = false;
  for (const [k, pid] of Object.entries(v.perKat)) if (!ada.has(pid)) { delete v.perKat[k]; ubah = true; }
  if (v.aktif && !ada.has(v.aktif)) { v.aktif = ""; ubah = true; }
  if (ubah) simpan(v);
}

/** Parameter permintaan keranjang (kosong bila belum ada pilihan → perilaku bawaan). */
export function paramSasaran() {
  const v = bacaSasaran();
  const p = {};
  const ids = Object.values(v.perKat);
  if (ids.length) p.sasaran = ids.join(",");
  if (v.aktif) p.aktif = v.aktif;
  return p;
}

/** Hanya untuk tes: lupakan salinan memori (seperti muat ulang halaman). */
export function lupakanMemoriSasaran() { memori = null; }
